// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2EF0r","clinicsSelect":"TableHeading_clinicsSelect__HmB10"};